import styled, { css } from 'styled-components';

export const Box = styled.div<{ $isInCard?: boolean }>`
  position: absolute;
  z-index: 1;
  display: flex;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.system.white};
  ${({ $isInCard }) =>
    $isInCard
      ? css`
          right: 10px;
          bottom: 10px;
        `
      : css`
          left: 15px;
          bottom: 15px;

          @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
            bottom: 10px;
          }
        `};
`;
